import { SidebarProvider, SidebarInset } from '../../components/ui/sidebar';
import { AppSidebar } from './AppSidebar';
import { WalletUnlockModal } from '../../components/wallet/WalletUnlockModal';
import { WalletSetupModal } from '../../components/wallet/WalletSetupModal';

interface MainLayoutProps {
  children: React.ReactNode;
}

export function MainLayout({ children }: MainLayoutProps) {
  return (
    <SidebarProvider>
      <div className="flex min-h-screen w-full">
        <AppSidebar />
        <SidebarInset className="flex-1">
          <main className="flex-1 p-6 md:p-8">
            {children}
          </main>
        </SidebarInset>
      </div>
      <WalletUnlockModal />
      <WalletSetupModal />
    </SidebarProvider>
  );
}
